<template>
  <div class="w-per100 sticky top0 left0 zIndex100 row flex-center bg_fff">
    <div class="w-per62_5 row j-sb a-center">
      <img
        class="logoimg1"
        :src="logo"
        alt=""
        @click="handleShow(0)"
      />

      <ul class="row">
        <li
          class="row flex-center ft16 lh60 c_333 relative pointer ml60"
          v-for="(item, index) in navList"
          :key="index"
          @click="handleShow(index)"
        >
          <span :class="current==index?'c_F97316':''">{{ item.name }}</span>
          <div class="absolute bottom0 left-per50 trX-per50 w-per100" :class="current==index?'line-nav':''"></div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {getConfig} from "@/api/app"
export default {
  data() {
    return {
      navList: [],
      logo: "",
    }
  },
  props: {
    current: Number,
  },
  mounted() {
    this.fetchIndex();
    this.fetchConfig()
  },
  methods: {
    handleShow(index) {
      this.$emit("onHandleShow", index)
    },
    // 首页
    async fetchIndex() {
      this.navList = [
        {name: '首页'},{name: '营销传播'},{name: '活动策划'},{name: '综合服务'},{name: '关于我们'}
      ]
    },
    async fetchConfig() {
      let params = {name: 'logo'}
      let {data} = await getConfig(params);
      // console.log('data',data);
      this.logo = data.data.list.logo
    },
  },
}
</script>
<style lang="scss" scoped>
.logoimg1{
  width: 132px;
  height: 60px;
}
.line-nav{
  height: 3px;
  background: #F97316;
  border-radius: 2px;
}
.c_333:hover{
  color: #F97316;
}
</style>
